import React, { useEffect } from 'react';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { getNotificationPreferences, updateNotificationPreferences } from '../../services/userService';
import { notificationPreferencesMapper } from '../../utils/constants';

const notificationPreferenceSortObject = ['chartAllocation', 'newCommentInConversationLog', 'qcStatusChange', 'prioritizationConditionsChange', 'requestedReportUpdate'];

function NotificationSettings({ onHide }) {
  const [isUpdating, setIsUpdating] = useState(false);
  const [configurationId, setConfigurationId] = useState(null);
  const [notificationPreferences, setNotificationPreferences] = useState(null);

  const fetchNotificationPreferences = async () => {
    try {
      const response = await getNotificationPreferences();
      if (response?.success) {
        const role = (localStorage.getItem('Role'));
        if (role === 'Team Lead' || role === 'Manager') {
          const data = response?.data?.filter(item => item?.NotificationType?.name === 'requestedReportUpdate');
          setNotificationPreferences(data);
        } else {
          const data = response?.data?.filter(item => item?.NotificationType?.name !== 'requestedReportUpdate');
          setNotificationPreferences(data);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
     fetchNotificationPreferences();
  }, []);

  const handlePermissionChange = async (e, configId) => {
    setConfigurationId(configId);
    setIsUpdating(true);
    try {
      const reqBody = {
        id: configId,
        status: e.target.checked,
      };
      const response = await updateNotificationPreferences({ data: reqBody });
      if (response?.success) {
        fetchNotificationPreferences();
      } else {
        window.toastr.error(response?.message ?? 'Please try again!');
      }
    } catch (error) {
      console.log(error);
      window.toastr.error(error?.message ?? 'Please try again!');
    }
    setConfigurationId(null);
    setIsUpdating(false)
  };

  return (
    <Modal show centered onHide={onHide} size="lg">

      <Modal.Header className="pb-2" closeButton>
        <Modal.Title>
          <h2> Notification Preferences </h2>
        </Modal.Title>
      </Modal.Header>
      <div className="modal-body  mb-4">
        <h5 className="mb-6">Notify on Chart Activities: </h5>

        {
         (notificationPreferences)?.sort((a, b) => notificationPreferenceSortObject.indexOf(a?.NotificationType?.name) - notificationPreferenceSortObject.indexOf(b.NotificationType?.name))?.map((config) => config?.NotificationType?.name === 'prioritizationConditionsChange' ? null : (
            <div key={config?.NotificationType?.id} className="d-flex flex-stack border border-gray-300 border-dashed rounded py-6 ps-6 mt-4">
              <div className="d-flex align-items-center me-5">
                <div className="me-5">
                  <Link className="fw-bold text-gray-800 text-hover-primary fs-7">{notificationPreferencesMapper[config?.NotificationType?.name]}</Link>
                </div>
              </div>
              <div className="text-gray-500 fw-bold fs-7 text-end">
                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                  {(isUpdating && configurationId === config?.NotificationType.id) && <span className="me-6 spinner-border spinner-border-sm align-middle ms-2" />}
                  <input
                    key={config?.NotificationType.id}
                    onChange={(e) => handlePermissionChange(e, config?.NotificationType.id)}
                    className="form-check-input h-20px w-30px cursor-pointer"
                    type="checkbox"
                    checked={config?.isEnabled}
                  />
                </div>

              </div>
            </div>
          ))}
      </div>

    </Modal>
  )
}

export default NotificationSettings